
import { defineComponent,onMounted,reactive,ref,toRefs,getCurrentInstance, watch, nextTick} from 'vue'
import Head from './common/headNav.vue'
import {useStore} from 'vuex'
import {useRouter,useRoute} from 'vue-router'
import Footer from '@/components/common/footer.vue'
import tool from '@/utils/plugins/tools.js'
export default defineComponent({
    components:{
        Head,
        Footer
    },
    setup() {
        const {proxy,appContext} = getCurrentInstance() as any;
        const store=useStore()
        const router=useRouter()
        const Cookies = appContext.app.config.globalProperties.Cookies
        // const route= useRoute()
        // console.log(route.path)
        // router.beforeEach((to,from ,next)=>{
        //     console.log(to,'to')
        // })
        const state:any=reactive({
            isScroll:false,//是否触发滚动
            showSearch:false,//是否显示顶部搜索框
        })
        const methods:any=reactive({
            listenerScroll:(e:any)=>{
               let scrollTop=document.documentElement.scrollTop || document.body.scrollTop||proxy.$refs.help.scrollTop
                if(scrollTop>10){
                    state.isScroll=true
                }else{
                    state.isScroll=false
                }
                if(scrollTop>store.state.searchTop){
                    state.showSearch=true
                }else{
                    state.showSearch=false
                }
                store.commit('SET_HEAD_HEIGHT',scrollTop)
            },
            toPaasSix:()=>{
                window.open('https://docs.awspaas.com/help6/index.html','_blank')
            },
            handleClick:()=>{
                window.open(location.href+'?name=111')
            }
        })
        onMounted(()=>{
            let dom=proxy.$refs.help
            dom.addEventListener('scroll',methods.listenerScroll,true)
            tool.dataPiont({
                channelName:"AWS PaaS-帮助中心",
                behaviorNo:"0101",
                eventNo:tool.searchParam("_event")||tool.searchParam("utm_campaign"),
                browserId:Cookies.get("BROWSER_ID")||appContext.app.config.globalProperties.$fingerprint,
                url:window.location.href,
                title:document.title,
                utmsource:tool.searchParam("utm_source"),
                visitDate:tool.getCurrentFormattedTime(),
                device:tool.isMobile()?'mobile':'pc',
                mobile:'',
                visitType:'A'
            })

        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    }
})
